module.exports = __webpack_public_path__ + "assets/img/b2c-hero-1.76ff6591.png";